// extracted by css-extract-rspack-plugin
export default {"cls1":"MultiPaperNewsStory-cls1_Djc","cls2":"MultiPaperNewsStory-cls2_ft7 MultiPaperNewsStory-cls1_Djc"};